<template>
  <div class="agreementStyle">
    <van-popup
      v-model="show"
      round
      class="inPop"
    >
      <component
        :is="contract"
        :hidePopup="hidePopup"
        :urlLink="url"
      ></component>
    </van-popup>
    <div class="agreement">
      <img
        class="selectImg"
        @click="clickAgree()"
        :src="imgUrlAgreement"
        alt=""
      >
      <span
        class="agreementText"
        @click="clickAgree()"
      >我已阅读并同意</span>
      <!-- <br/> -->
      <span
        class="agreement_content"
        @click="showClick(item.value)"
        v-for="(item, index) in list"
        :key="item.value"
      >《{{ item.text }}》{{list.length > index && index &lt; list.length-1? '、' : ''}}</span>
    </div>
  </div>
</template>
<script>
import NoSelect from '@/assets/images/weixuanzhong.png';
import Select from '@/assets/images/xuanzhong.png';
// 苏宁 --《最高额保证合同》
import suningMaximumGuaranteeContract from '@/components/FeildTwo/components/suningMaximumGuaranteeContract.vue';
// 苏宁 --《发票贷借款合同（企业版）》
import suningInvoiceLoanEnterprise from '@/components/FeildTwo/components/suningInvoiceLoanEnterprise.vue';

// 浦发 协议
import PufaCredit from '@/components/FeildTwo/components/PufaCredit.vue';

// 浦发 PDF
import PufaPdf from '@/components/FeildTwo/components/PufaPdf.vue';


export default {
  name: 'Contract',
  data() {
    return {
      agreeWithAgreement: true,
      contract: '',
      show: false,
      imgUrlAgreement: Select,
    };
  },
  props: {
    list: {
      default: () => [],
      type: Array,
    },
    pageData: {
      type: Object,
      default: () => ({}),
    },
    text: String,
    value: Boolean,
  },
  components: {
    suningMaximumGuaranteeContract,
    suningInvoiceLoanEnterprise,
    PufaCredit,
    PufaPdf,
  },
  mounted() {
  },
  computed: {
    url() {
      const url = this.pageData.contractUrls ? this.pageData.contractUrls[this.contract] : '';
      return `${window.location.origin}/backloansuper/loan/supermarket${url}`;
    },
  },
  methods: {
    showClick(val) {
      this.show = true;
      this.contract = val;
    },
    hidePopup() {
      this.show = !this.show;
    },
    clickAgree() {
      this.agreeWithAgreement = !this.agreeWithAgreement;
      this.imgUrlAgreement = this.agreeWithAgreement ? Select : NoSelect;
      this.$emit('getBtnStatus', this.agreeWithAgreement);
    },
  },
};
</script>
<style scoped>
.inPop {
  width: 90%;
  height: 90%;
  padding: 10px;
}

.inPop >>> .inPop a#close {
  background: none;
  color: #000;
}

.agreement {
  box-sizing: border-box;
  margin-top: 10px;
  /* margin: 0 15px 0 15px; */
  color: #9ea7b4;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  position: relative;
}
.agreement .agreement_content {
  color: #ff6538;
}
.selectImg {
  width: 12px;
  position: absolute;
  top: 5px;
  left: 0;
}
.seletedColor {
  color: #ff6538;
}
.agreementText {
  margin-left: 20px;
}
.agreementStyle {
  padding: 0 16px;
}
</style>
